// src/components/productFormFields/CategoryDialog.tsx
import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, useMediaQuery, useTheme } from "@mui/material";
import DesktopCategoryCols from "./DesktopCategoryCols";
import MobileCategoryList from "./MobileCategoryList";
import { Category } from "../../types";

interface Props {
  open: boolean;
  onClose: () => void;
  categories: Category[];
  onSelectCategory: (cat: Category) => void;
}

// CategoryDialog - решает, как показать список категорий (моб/десктоп)
const CategoryDialog: React.FC<Props> = ({
  open,
  onClose,
  categories,
  onSelectCategory
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Состояние "активных категорий" для десктопной версии
  const [activeCategories, setActiveCategories] = useState<Category[]>([]);

  // Обработчик "наведения" для десктопа
  const handleMouseEnter = (category: Category, level: number) => {
    setActiveCategories((prev) => [...prev.slice(0, level), category]);
  };

  const handleClickCategory = (cat: Category) => {
    onSelectCategory(cat);
    // Закрываем диалог и сбрасываем активные категории
    setActiveCategories([]);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      PaperProps={{
        sx: {
          width: "90vw", // Адаптивная ширина
          maxWidth: "1100px",
          height: "90vh", // Фиксированная высота
          maxHeight: "90vh", // Ограничение по высоте экрана
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DialogTitle>Выберите категорию</DialogTitle>
      <DialogContent
        sx={{
          flexGrow: 1, // Заполняет доступное пространство
          overflow: "hidden", // Исключаем скролл всего контента
          display: "flex",
          flexDirection: "column",
          minWidth: 300,
        }}
      >
        <div
          style={{
            display: "flex",
            flexGrow: 1,
            overflowY: "auto", // Добавляем скролл только внутри списка категорий
            maxHeight: "75vh", // Чтобы не выходило за границы экрана
          }}
        >
          {isMobile ? (
            <MobileCategoryList
              categories={categories}
              onCategoryClick={handleClickCategory}
            />
          ) : (
            <DesktopCategoryCols
              categories={categories}
              activeCategories={activeCategories}
              onMouseEnterCategory={handleMouseEnter}
              onClickCategory={handleClickCategory}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CategoryDialog;
